module.exports = __webpack_public_path__ + "img/cszq_partners_2.fa4404bb.jpg";